export default "__VITE_ASSET__zYsVCnrAtTlaxTYG3FQt_A__"